<template>
  <section id="nousrejoindre" class="py-20 bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Contactez-nous
        </h2>
        <p class="text-xl text-gray-600 max-w-3xl mx-auto">
          Une question ? Une suggestion ? N'hésitez pas à nous contacter, nous
          serons ravis de vous répondre
        </p>
      </div>

      <div class="grid md:grid-cols-2 gap-12">
        <div>
          <h3 class="text-2xl font-bold text-gray-900 mb-8">
            Informations de Contact
          </h3>

          <div class="space-y-6">
            <div class="flex items-start space-x-4">
              <div class="bg-indigo-100 p-3 rounded-full">
                <svg
                  class="w-6 h-6 text-indigo-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  ></path>
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  ></path>
                </svg>
              </div>
              <div>
                <h4 class="font-semibold text-gray-900 mb-1">Siège Social</h4>
                <p class="text-gray-600">
                  31, Rue 1er Novembre<br />
                  Bir El Djir - Oran<br />
                  BR52-RP-31000 - Algérie
                </p>
              </div>
            </div>

            <div class="flex items-start space-x-4">
              <div class="bg-indigo-100 p-3 rounded-full">
                <svg
                  class="w-6 h-6 text-indigo-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  ></path>
                </svg>
              </div>
              <div>
                <h4 class="font-semibold text-gray-900 mb-1">Téléphone</h4>
                <p class="text-gray-600">0671 15 32 16</p>
              </div>
            </div>

            <div class="flex items-start space-x-4">
              <div class="bg-indigo-100 p-3 rounded-full">
                <svg
                  class="w-6 h-6 text-indigo-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  ></path>
                </svg>
              </div>
              <div>
                <h4 class="font-semibold text-gray-900 mb-1">Email</h4>
                <p class="text-gray-600">contact@amgoran.dz</p>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-xl shadow-lg p-8">
          <h3 class="text-2xl font-bold text-gray-900 mb-6">
            Envoyez-nous un Message
          </h3>

          <form class="space-y-6" @submit.prevent="sendMessage">
            <div class="grid md:grid-cols-2 gap-4">
              <div>
                <label for="contact-prenom" class="sr-only">Prénom</label>
                <input
                  id="contact-prenom"
                  type="text"
                  placeholder="Prénom"
                  v-model="prenom"
                  name="prenom"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
                <div class="msg-error" v-if="error.prenom">{{ error.prenom }}</div>
              </div>
              <div>
                <label for="contact-nom" class="sr-only">Nom</label>
                <input
                  id="contact-nom"
                  type="text"
                  placeholder="Nom"
                  v-model="nom"
                  name="nom"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
                <div class="msg-error" v-if="error.nom">{{ error.nom }}</div>
              </div>
            </div>

            <div>
              <label for="contact-email" class="sr-only">Email</label>
              <input
                id="contact-email"
                type="email"
                placeholder="Email"
                v-model="email"
                name="email"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
              <div class="msg-error" v-if="error.email">{{ error.email }}</div>
            </div>

            <div>
              <label for="contact-sujet" class="sr-only">Sujet</label>
              <select
                id="contact-sujet"
                v-model="sujet"
                name="sujet"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              >
                <option value="" disabled>Choisissez un sujet</option>
                <option>Demande d'information</option>
                <option>Proposition de partenariat</option>
                <option>Autre</option>
              </select>
              <div class="msg-error" v-if="error.sujet">{{ error.sujet }}</div>
            </div>

            <div>
              <label for="contact-message" class="sr-only">Message</label>
              <textarea
                id="contact-message"
                rows="5"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                placeholder="Votre message..."
                v-model="message"
                name="message"
              ></textarea>
              <div class="msg-error" v-if="error.message">
                {{ error.message }}
              </div>
            </div>

            <div class="msg-error" v-if="error.recaptcha">
              {{ error.recaptcha }}
            </div>

            <Recaptcha :siteKey="siteKey" ref="recaptcha" />

            <div class="text-red-600 text-sm" v-if="server">{{ server }}</div>
            <div class="text-green-600 text-sm font-medium" v-if="success">
              Votre message a été envoyé. Merci !
            </div>
            <input v-model="honeypot" type="text" style="display: none" tabindex="-1" autocomplete="off" aria-hidden="true" />
            <button
              type="submit"
              :disabled="loading"
              class="w-full bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              <svg v-if="loading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              {{ loading ? 'Envoi en cours...' : 'Envoyer le Message' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Recaptcha from "../plugins/Recaptcha.vue";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  components: { Recaptcha },
  name: "Contact",
  data() {
    return {
      siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      loading: false,
      success: false,
      honeypot: "",
      nom: "",
      prenom: "",
      email: "",
      sujet: "Demande d'information",
      message: "",
      formStart: null,
      error: {
        nom: "",
        prenom: "",
        email: "",
        message: "",
        recaptcha: "",
        sujet: "",
      },
      server: "",
    };
  },
  mounted() {
    this.formStart = Date.now();
  },
  methods: {
    validate() {
      this.error.nom = !this.nom.trim() ? "Vous devez entrer le nom" : "";
      this.error.prenom = !this.prenom.trim() ? "Vous devez entrer le prénom" : "";
      this.error.email = !this.email.trim()
        ? "Vous devez entrer l'email"
        : !EMAIL_REGEX.test(this.email)
        ? "Veuillez entrer un email valide"
        : "";
      this.error.message = !this.message.trim() ? "Vous devez écrire un message" : "";
      this.error.sujet = !this.sujet ? "Vous devez choisir un sujet" : "";
      this.error.recaptcha = "";

      return !this.error.nom && !this.error.prenom && !this.error.email && !this.error.message && !this.error.sujet;
    },

    resetForm() {
      this.nom = "";
      this.prenom = "";
      this.email = "";
      this.message = "";
      this.sujet = "Demande d'information";
      this.honeypot = "";
      this.error = { nom: "", prenom: "", email: "", message: "", recaptcha: "", sujet: "" };
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
      }
      this.formStart = Date.now();
    },

    async sendMessage() {
      this.server = "";
      this.success = false;

      if (!this.validate()) return;

      // Honeypot check
      if (this.honeypot && this.honeypot.trim() !== "") {
        return;
      }

      // Minimum time check
      const elapsed = (Date.now() - this.formStart) / 1000;
      if (elapsed < 3) {
        return;
      }

      // reCAPTCHA check
      let recaptchaToken = "";
      try {
        if (typeof window.grecaptcha !== "undefined") {
          recaptchaToken = window.grecaptcha.getResponse();
          if (!recaptchaToken) {
            this.error.recaptcha = "Veuillez compléter le reCAPTCHA";
            return;
          }
        } else {
          this.error.recaptcha = "reCAPTCHA n'est pas encore chargé. Veuillez réessayer plus tard.";
          return;
        }
      } catch (error) {
        this.error.recaptcha = "reCAPTCHA n'est pas encore chargé. Veuillez réessayer plus tard.";
        return;
      }

      // Build plain text body (no raw HTML injection)
      const body = [
        `Email: ${this.email}`,
        `Nom: ${this.nom} ${this.prenom}`,
        `Sujet: ${this.sujet}`,
        `Message: ${this.message}`,
      ].join("\n");

      this.loading = true;

      try {
        const res = await fetch(
          `${process.env.VUE_APP_HSERVER_URL}/amgoran/send_email`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              to: process.env.VUE_APP_EMAIL_TO_AMGORAN,
              subject: `Contact depuis le site AMGO: ${this.sujet}`,
              html: body,
              replyTo: this.email,
              recaptcha: recaptchaToken,
            }),
          }
        );

        const responseText = await res.text();

        if (!res.ok || responseText.startsWith("Error")) {
          this.server = "L'envoi du courrier a échoué, réessayez plus tard";
        } else {
          this.success = true;
          this.resetForm();
        }
      } catch (error) {
        this.server = "L'envoi du courrier a échoué, réessayez plus tard";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.msg-error {
  color: red;
  font-size: 12.5px;
  min-height: 20px;
}
</style>
